//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { Enums } from '../../../models/common/enums'
import { Activity } from '../../../models/common/activity'
import { IUserSession } from '../../../helpers/user-session'

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { EventsNames } from '../../../helpers/events-names'
import { OperatorLayoutSettings } from './../../../helpers/operator-layout-settings'
import { CreateEditInitParams } from '../../common/create-edit-popup/create-edit-popup.controller'
import { i18n } from '../../common/i18n/common.i18n'
import { Details, DetailsScope, DetailsAccordion, DetailsAccordionSection } from '../../common/common.details'
import { CommonHelper } from '../../../helpers/common-helper'
import { DetailsPopupOptions } from '../../common/details-popup/details-popup.directive'
import { HistorySource } from '../../common/history/history.directive.controller'
import { DetailsParametersOptions } from '../../common/details-parameters/details-parameters.directive'

import { OpDataTypeInGroup } from '../../../models/core/op-data-type-in-group'
import { OpSimCard } from '../../../models/core/op-sim-card'
import { SESSION } from '../../../models/custom/session'
import { TemplateHelper, LocalizationHelper, ConfigHelper } from '../../../helpers'

interface CommonData {//DO USUNIECIA!!!
    detailsParametersOptions: DetailsParametersOptions
    locations: any[]
}

interface SimcardDetailsScope extends DetailsScope {
    id: number
    idReferenceObject: number//TO DO!!! do DetailsScope zamiast modelId
    itemObjects: any[]
    popupTitle: string

    common: CommonData

    confirmDelete()

    historySource: HistorySource
}

export class SimcardDetailsDirectiveController extends Details<SimcardDetailsScope> {
    private referenceObject: OpSimCard

    constructor($scope: SimcardDetailsScope, $q: ng.IQService, $timeout: ng.ITimeoutService, private api: Api, logger: LoggerService, localDictionary: LocalDictionaryFactory,
        protected userSession: IUserSession, protected referenceType: Enums.ReferenceType) {
        super($scope, $timeout, $q, logger, localDictionary, OperatorLayoutSettings.SimcardPopupTabActive, userSession, referenceType)

        this.setEvents()
        this.setOptions()

        if (this.userSession.getLoggedOperator().hasPermission(Activity.SIM_CARD_LIST)) {
            this.configureTabs(this.getTabs())
        }
    }

    onOpen(idReferenceObject: number, previousNextIdReferenceObjects: any[]) {
        this.onClear()

        this.$scope.idReferenceObject = idReferenceObject
        this.$scope.modelId = this.$scope.idReferenceObject
        this.$scope.itemObjects = previousNextIdReferenceObjects

        this.$scope.historySource = {
            id: idReferenceObject,
            dataMethodName: 'getHistoryForSimcard',
            name: 'simcardsHistory',
            allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.SimCardHistory),// !$root.hasPermissions(['SIMCARD_MODULE_SIMCARD_HISTORY_GRID_COLUMN_REORDER_DISALLOWED'])
            referenceType: this.referenceType,
            referenceValue: idReferenceObject
        }
        this.showPopup()
        this.onRefresh()
    }
    onRefresh(toRefresh: OpSimCard = null) {
        this.$scope.options.isDataLoaded = false
        const deferred: JQueryDeferred<OpSimCard> = $.Deferred<OpSimCard>()

        if (!toRefresh) {
            this.userSession.getDataProvider().SimCard.getSimCard(this.$scope.idReferenceObject).then(result => {
                this.$scope.popupTitle = result.toString()
                this.$scope.showTabs = true
                deferred.resolve(result)
            }).fail(err => {
                var errorMsg: string = err
                if (SESSION.isType(err))
                    errorMsg = (<SESSION>err).toString()
                this.logger.log(errorMsg)
                this.$scope.showTabs = true
                deferred.resolve(null)
            })
        } else {
            deferred.resolve(toRefresh)
        }

        deferred.promise()
            .then(result => {
                if (result) {
                    if (!this.referenceObject || this.referenceObject.idSimCard == result.idSimCard) {
                        this.referenceObject = result
                        //Refresh Base/ExtendedParameters
                        return this.setBasicParameters()
                    }
                }
            })
            .always(() => {
                this.$scope.options.isDataLoaded = true
            })
    }

    private setBasicParameters(): JQueryPromise<void> {
        const def: JQueryDeferred<void> = $.Deferred<void>()
        this.$scope.detailsParametersOptions = null

        this.userSession
            .getDataProvider().DataTypeGroup
            .getDataTypeInGroup(Enums.DataTypeGroup.WEBSIMAX_SIM_CARD_PANEL_PARAMS_TO_DISPLAY)
            .then((dataTypeInGroup: OpDataTypeInGroup[]) => {
                this.$scope.common.detailsParametersOptions = {
                    dataTypes: dataTypeInGroup,
                    referenceType: this.referenceType,
                    referenceObject: this.referenceObject,
                    useDynamicValues: true,
                    onDataLoaded: () => {
                        def.resolve()
                    }
                }
            })
            .catch(() => {
                def.reject()
            })

        if (this.isAccordionHidden('params')) {
            def.resolve()
        }

        return def.promise()
    }

    onEditParams() {
        var createEditInitParams: CreateEditInitParams =
        {
            moduleName: Enums.SimaxModuleName.Sim_Card,
            idReferenceType: this.referenceType,
            createEditSelectedTabType: Enums.SimaxCreateEditSelectedTabType.BaseParameters,
            groupReferenceType: null,
            groupReferenceValue: null,
            referenceObjectId: this.referenceObject.idSimCard,
            referenceObject: this.referenceObject,
            sections: null,
            useBusinessObjects: true
        }
        this.$scope.$root.$broadcast(EventsNames.INITIALIZE_CREATE_EDIT_POPUP, createEditInitParams)
    }
    onClear() {
        this.$scope.popupTitle = ''
        this.$scope.showTabs = false

        this.referenceObject = null
        this.$scope.common.detailsParametersOptions = null
        this.$scope.common.locations = []
    }
    onClose() {
        this.hidePopup()
    }
    onConfirmDelete() {
        this.userSession.getDataProvider().SimCard.deleteSimCard(new OpSimCard({ ID_SIM_CARD: this.$scope.modelId })).then(result => {
            this.$scope.$root.$broadcast(EventsNames.SIM_CARD_DELETED)
            this.onClose()
            CommonHelper.openInfoPopup(i18n('Popup', 'SimcardDeleted'))
        }).fail(err => {
            var errorMsg: string = err
            if (SESSION.isType(err)) {
                errorMsg = (<SESSION>err).toString()
                CommonHelper.openInfoPopup(errorMsg, 'error', 4000)
            } else
                CommonHelper.openInfoPopup(i18n('Popup', 'SimcardDeleteError'), 'error', 4000)
            this.logger.log(errorMsg)
        })
    }

    getTabs() {
        var tabs = []
        tabs.push({
            template: TemplateHelper.getContextMenuItem(
                LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Common),
                ConfigHelper.Icon.HOME,
                this.userSession
            ),
            name: 'common'
        })
        return tabs
    }
    getAccordions() {
        var accordions: DetailsAccordion[] = []

        var items: DetailsAccordionSection[] = []

        items.push({
            title: i18n("Common", "BasicParameters"),
            canEdit: this.userSession.getLoggedOperator().hasPermission(Activity.SIM_CARD_EDIT) && !this.userSession.getLoggedOperator().hasPermission(Activity.SIM_CARD_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.SimCardParameters),
            name: 'params',
            showStatus: false,
            editMethod: () => {
                if (this.userSession.getLoggedOperator().hasPermission(Activity.SIM_CARD_EDIT) && !this.userSession.getLoggedOperator().hasPermission(Activity.SIM_CARD_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.SimCardParameters))
                    this.onEditParams()
            },
            visible: true
        })

        accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.SimcardDetailsAccordions, 0, items))

        if (!this.userSession.getLoggedOperator().hasPermission(Activity.SIM_CARD_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.SimCardHistory)) {
            var items: DetailsAccordionSection[] = []

            items.push({
                title: i18n("Common", "History"),
                canEdit: false,
                name: 'history',
                showStatus: false,
                visible: true
            })

            accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.SimcardDetailsAccordions, 1, items))
        }

        return accordions
    }

    setEvents() {
        // onOpen
        this.$scope.$on(EventsNames.SIM_CARD_OPEN_DETAILS_POPUP + this.$scope.id, (event: ng.IAngularEvent, ...args: any[]) => { this.onOpen(args[0], args[1]) })
        // onClose
        this.$scope.$on(EventsNames.SIM_CARD_CLOSE_DETAILS_POPUP + this.$scope.id, () => { this.onClose() })
        // onRefresh - close create-edit popup
        this.$scope.$on(EventsNames.CLOSE_CREATE_EDIT_POPUP, (event: ng.IAngularEvent, ...args: any[]) => { this.onRefresh(args[0]) })
        // delete
        this.$scope.confirmDelete = () => { this.onConfirmDelete() }
    }
    setOptions() {
        this.$scope.common = <CommonData>{}
        this.$scope.requestsStates = {}
        this.accordionsNameToShow = 'common'

        this.$scope.options = <DetailsPopupOptions>{
            title: i18n('Popup', 'SimcardDetails'),
            openEventName: EventsNames.SIM_CARD_OPEN_DETAILS_POPUP,
            closeEventName: EventsNames.SIM_CARD_CLOSE_DETAILS_POPUP,
            deleteMethod: () => { this.$scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.detailsPopupId, i18n('Popup', 'ConfirmDeleteSimcard')) },
            delHasPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.SIM_CARD_DEL) ? Activity[Activity.SIM_CARD_DEL] : null,
            id: this.$scope.id,
            getAccordionDataMethod: () => { return this.getAccordionData() },
            getAccordionSelectionMethod: () => { return this.getAccordionSelection() },
            updateAccordionMethod: (names: any[]) => { return this.updateAccordions(names) }
        }
    }



    resetData() { this.onClear() }//DO USUNIECIA!!! - zastąpić onClear
    loadData(id: number, objects: any[]) { this.onOpen(id, objects) }//DO USUNIECIA!!! - zastąpić onOpen
    updateData(result: any) { this.onRefresh(result) }//DO USUNIECIA!!! - zastąpić onRefresh
}